// src/pages/settings/generalSettings.js
import React from "react";
import { Select } from "antd";
import SettingsRow from "./components/settingsRow";

const GeneralSettings = ({ data, onFieldChange }) => (
  <div className="stg-sub-page">
    <SettingsRow label="Theme">
      <Select
        value={data.theme}
        onChange={(v) => onFieldChange("theme", v)}
        className="stg-dropdown"
        options={[
          { value: "light", label: "Light" },
          { value: "dark", label: "Dark" }
        ]}
      />
    </SettingsRow>
  </div>
);

export default GeneralSettings;
